import { defineComponent } from 'vue';
import Selection from '@common/selection/Selection.vue';
import { Field, ErrorMessage } from 'vee-validate/compat';
import Validator from '@common/veeValidate/Validator';
import validation from '@common/mixins/validation';
import translator from '~/zf/frontend/common/mixins/translator';
import ApiService from '../../../../../administration/pages/viiu/muteAndAutoClose/services/ApiService';
import AlertService from '~/zf/frontend/common/alert/AlertService';
export default defineComponent({
    name: 'ComponentSelection',
    components: {
        Field,
        ErrorMessage,
        Selection,
    },
    mixins: [translator, validation],
    compatConfig: {
        MODE: 3,
    },
    props: {
        modelValue: {
            type: [Object, null],
            required: true,
        },
    },
    emits: ['update:model-value'],
    data() {
        return {
            Validator,
            isLoading: false,
            componentFilterOptions: [],
        };
    },
    async created() {
        this.isLoading = true;
        try {
            this.componentFilterOptions = await ApiService.loadComponentFilterOptions();
            this.componentFilterOptions = this.componentFilterOptions
                .map((option) => ({ ...option, groupName: this.tr(option.groupName) }));
        }
        catch {
            AlertService.showError(this.tr('viiu.componentMuting.LOAD_COMPONENT_SELECTION_FAILED'));
        }
        finally {
            this.isLoading = false;
        }
    },
});
